import React from 'react';
import Bar from '../../components/Bar';
import '../../Home.css';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import PrivacyPolicyComponent from './privacyPolicy';

class PrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
    }

    static async getInitialProps({ req, res, match, history, location, domain, ...ctx }) {
        if (req) {
            return {
                domain
            };
        }

        return {};
    }
    render() {
        const { props } = this;
        const { domain } = props;

        return (
            <div className="Home">
                <CssBaseline />
                <Bar domain={domain} />
                <Container component="main">
                    <PrivacyPolicyComponent domain={ domain }/>
                </Container>
            </div>
        );
    }
}

export default PrivacyPolicy;